module.exports = __webpack_public_path__ + "img/whatsapp.ca54ba2a.svg";